import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
export default function () {
  extend('flarum/forum/components/NotificationGrid', 'notificationTypes', function (items) {
    items.add('discussionMerged', {
      name: 'discussionMerged',
      icon: 'fas fa-code-branch fa-flip-vertical',
      label: app.translator.trans('fof-merge-discussions.forum.notification.preferences.discussion_merged')
    });
  });
}